module.exports = __webpack_public_path__ + "ubisoft-forward-logo.svg";